import {initializeOsanoQaTesting} from '/src/com/yext/storm/js/osano/qatesting';

var initElements = document.getElementsByClassName('js-osano-init');

if (initElements.length > 0) {
  const initData = JSON.parse(initElements[0].innerHTML);
  if (initData['cspStyleNonce']) {
    window['__CSP_NONCE'] = initData['cspStyleNonce'];
  }
}

initializeOsanoQaTesting();
